import { formatHex, parse } from 'culori';
import twColors from 'tailwindcss/colors';

function twHex(color) {
  if (typeof color !== 'string') return color;
  if (!color.startsWith('oklch(')) return color;

  const parsed = parse(color);
  if (!parsed) return color;

  return formatHex(parsed);
}

const primaryMain = twHex(twColors.blue[600]);

/**
 * Re-assert MUI Button text colors on interactive states when the root is an <a>.
 * Bootstrap's global `a:hover { color: ... }` otherwise overrides button label color.
 */
export const muiButtonLinkRootOverride = {
  'a&': {
    '&:hover, &:focus, &:visited': {
      textDecoration: 'none',
    },
  },
};

export const muiButtonLinkStyleOverrides = {
  textPrimary: {
    '&:hover, &:focus, &:visited': {
      color: primaryMain,
    },
  },
  textSecondary: {
    '&:hover, &:focus, &:visited': {
      color: primaryMain,
    },
  },
  outlinedPrimary: {
    '&:hover, &:focus, &:visited': {
      color: primaryMain,
    },
  },
  outlinedSecondary: {
    '&:hover, &:focus, &:visited': {
      color: primaryMain,
    },
  },
  containedPrimary: {
    '&:hover, &:focus, &:visited': {
      color: '#ffffff',
    },
  },
  containedSecondary: {
    '&:hover, &:focus, &:visited': {
      color: '#ffffff',
    },
  },
  contained: {
    '&:hover, &:focus, &:visited': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  colorInherit: {
    '&:hover, &:focus, &:visited': {
      color: 'inherit',
    },
  },
};
